// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2qVeo","info":"Note_info__3zaY6","note":"Note_note__3bT6N","actions":"Note_actions__2oBH5"};